<template>
    <div class="container">
        <div class="image"> </div>
        
        <div class="content">
            <header>
                <h1 class="main-title">
                    Admin Bereich
                </h1>
                <h2 class="subtitle">
                    Bitte melde dich an, um fortzufahren.
                </h2>
            </header>

            <section class="info-section">
                <h3 class="info-heading">
                    Login
                </h3>
                <p class="intro-paragraph">
                    Gib deine Zugangsdaten ein, um auf das Dashboard zuzugreifen.
                </p>
            </section>

            <form @submit.prevent="handleLogin" class="login-form">
                <div class="form-group">
                    <label for="username" class="input-label">Benutzername:</label>
                    <input id="username" v-model="username" type="text" required class="form-input" />
                </div>
                
                <div class="form-group">
                    <label for="password" class="input-label">Passwort:</label>
                    <input id="password" v-model="password" type="password" required class="form-input" />
                </div>

                <section class="action-area">
                    <button type="submit" class="button-next">
                        Anmelden
                    </button>
                </section>
            </form>
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'

const username = ref('')
const password = ref('')
const router = useRouter()

const handleLogin = () => {
    // 1. Combine username and password with a colon
    const credentials = `${username.value}:${password.value}`

    // 2. Base64 encode the string using btoa()
    const encodedCredentials = btoa(credentials)

    // 3. Save it to localStorage
    localStorage.setItem('demoBasicAuth', encodedCredentials)

    // 4. Redirect to the protected route
    // Note: Make sure the name matches the route definition in your router!
    // In your previous snippet, the child route wasn't named "Dashboard", 
    // so you might need to use router.push('/admin/dashboard') instead.
    router.push('/admin/dashboard')
}
</script>

<style scoped lang="scss">
.container {
    width: 100%;
    height: 92%;
    display: flex;
    overflow: hidden;

    .image {
        width: 50%;
        /* You might want to use a different image for the login page */
        background-image: url(./../../assets/welcome.png); 
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
    }

    .content {
        width: 100%;
        padding: var(--spacing-lg);
        overflow: scroll;
    }

    .main-title {
        color: var(--color-primary);
        font-size: var(--font-size-xl);
        margin-bottom: var(--spacing-sm);
    }

    .subtitle {
        color: var(--color-accent);
        font-size: var(--font-size-lg);
        margin-bottom: var(--spacing-xl);
    }

    .intro-paragraph {
        margin-bottom: var(--spacing-md);
        line-height: var(--line-height-base);
    }

    .info-section {
        margin-top: var(--spacing-lg);
        border-left: 4px solid var(--color-accent);
        padding-left: var(--spacing-md);
        margin-bottom: var(--spacing-lg);
    }

    .info-heading {
        color: var(--color-text-dark);
        margin-top: 0;
        margin-bottom: var(--spacing-sm);
    }
    
    /* --- New Form Styles --- */
    .login-form {
        display: flex;
        flex-direction: column;
        gap: var(--spacing-md);
        max-width: 400px; /* Keeps the form from getting too wide on large screens */
    }

    .form-group {
        display: flex;
        flex-direction: column;
        gap: var(--spacing-sm);
    }

    .input-label {
        font-weight: bold;
        color: var(--color-text-dark);
    }

    .form-input {
        padding: var(--spacing-md);
        border: 2px solid var(--color-accent);
        border-radius: 8px;
        font-size: var(--font-size-base, 1rem);
        outline: none;
        transition: border-color 0.2s ease;

        &:focus {
            border-color: var(--color-primary);
        }
    }

    .action-area {
        margin-top: var(--spacing-xl);
    }

    /* Adjusted .button-next to work as a <button> element */
    .button-next {
        background: var(--color-primary);
        color: var(--color-background-light) !important;
        text-decoration: none;
        font-size: var(--font-size-lg);
        padding-top: var(--spacing-md);
        padding-bottom: var(--spacing-md);
        display: block; 
        text-align: center;
        width: 100%;
        border: none;
        border-radius: 8px; /* Added slight rounding to match inputs */
        cursor: pointer;
        font-family: inherit;
        transition: opacity 0.2s ease;

        &:hover {
            opacity: 0.9;
        }
    }
}
</style>